<template>
  <table class="listado table table-hover">
    <thead class="bg-primary text-white">
      <th-ordenado titulo="Descripción" campo="descripcion" />
      <th-ordenado titulo="Descuento" campo="descuento" />
      <th-ordenado class="text-center" titulo="Activo" campo="estado" />
      <th-ordenado class="text-center" titulo="Responsable" campo="usablePorResponsable" />
      <th-ordenado class="text-center" titulo="Comercial" campo="usablePorComercial" />
      <th-ordenado class="text-center" titulo="Cuotas" campo="paraCuota" />
      <th-ordenado class="text-center" titulo="Servicios" campo="paraServicios" />
      <th class="th-acciones" width="260">Acciones</th>
    </thead>
    <tbody>
      <sin-registros v-show="!descuentos" :colspan="8" />
      <tr v-for="descuento in descuentos" :key="descuento.id" role="button">
        <td @click="editarDescuento(descuento.id)">
          {{ descuento.descripcion }}
        </td>
        <td @click="editarDescuento(descuento.id)">{{ descuento.descuento }} %</td>
        <td class="text-center" @click="editarDescuento(descuento.id)">
          <bool-check :value="descuento.estado" />
        </td>
        <td class="text-center" @click="editarDescuento(descuento.id)">
          <bool-check :value="descuento.usablePorResponsable" />
        </td>
        <td class="text-center" @click="editarDescuento(descuento.id)">
          <bool-check :value="descuento.usablePorComercial" />
        </td>
        <td class="text-center">
          <bool-check :value="descuento.paraCuota" />
        </td>
        <td class="text-center">
          <bool-check :value="descuento.paraServicios" />
        </td>
        <td nowrap="nowrap" class="td-acciones-auto">
          <b-button-group size="sm">
            <b-button variant="primary" class="actionButton" :to="`/descuentos/editar/${descuento.id}`">
              <v-icon variant="primary" name="edit" width="16" /><span>Editar</span>
            </b-button>
            <boton-eliminar @ok="$emit('eliminar', descuento.id)">
              ¿ Desea eliminar el descuento
              <b>{{ descuento.descripcion }}</b> ?
            </boton-eliminar>
          </b-button-group>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    descuentos: {
      type: Array,
      required: true,
    },
  },
  methods: {
    editarDescuento(descuentoId) {
      this.$router.push("/descuentos/editar/" + descuentoId);
    },
  },
};
</script>
